import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import React, { FC, ReactElement } from 'react';
import { Error } from '../../../components/Error';
import { NoResults } from '../../../components/no-results';
import { QueryLoading } from '../../../components/query-loading';
import { IOrderSimulation } from '../../../graphql/types';

export const GET_ORDER_SIMULATION = gql`
  query GetOrderSimulation(
    $soldToId: String!
    $shipToId: String!
    $productId: String!
    $quantity: String!
  ) {
    orderSimulation(
      soldToId: $soldToId
      shipToId: $shipToId
      productId: $productId
      quantity: $quantity
    ) {
      soldTo {
        id
        salesOrg
        address {
          name
          street
          city
          postalCode
          region
          country
        }
      }
      shipTo {
        id
        salesOrg
        address {
          name
          street
          city
          postalCode
          region
          country
        }
      }
      product {
        id
        description
        unitOfMeasure
        salesOrg
      }
      schedule {
        lineIndex
        desiredQuantity
        confirmedQuantity
        unitOfMeasure
        deliveryLeadTimeDate
        actualDeliveryDate
        backordered
        backorderQuantity
      }
    }
  }
`;

interface IGetOrderSimulationQueryProps {
  soldToId?: string;
  shipToId: string;
  productId: string;
  quantity: string;
  render: (orderSimulation: IOrderSimulation) => ReactElement;
}

const GetOrderSimulationQuery: FC<IGetOrderSimulationQueryProps> = ({
  soldToId,
  shipToId,
  productId,
  quantity,
  render,
}) => {
  const { data, loading, error } = useQuery(GET_ORDER_SIMULATION, {
    variables: {
      soldToId,
      shipToId,
      productId,
      quantity,
    },
  });

  if (loading) {
    return <QueryLoading />;
  } else if (error) {
    return <Error />;
  } else if (!data || !data.orderSimulation) {
    return <NoResults />;
  }
  return render(data.orderSimulation);
};

export { GetOrderSimulationQuery };
